<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                    <b-col cols="12" >
                        <b-form-group :label="$t('term')">
                            <ValidationProvider name="term" rules="required" v-slot="{valid, errors}">
                                <b-input-group class="mb-1"
                                               :class="errors[0] ? 'box-border-color-for-input-group' : ''"
                                >
                                    <b-form-input v-model="formData.term"/>
                                </b-input-group>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" >
                        <b-form-group :label="$t('definition')">
                            <ValidationProvider name="definition" rules="required" v-slot="{valid, errors}">
                                <b-input-group class="mb-1"
                                               :class="errors[0] ? 'box-border-color-for-input-group' : ''"
                                >
                                    <b-form-input v-model="formData.definition"/>
                                </b-input-group>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('reference')">
                            <ValidationProvider name="reference" rules="required" v-slot="{valid, errors}">
                                <b-input-group class="mb-1"
                                               :class="errors[0] ? 'box-border-color-for-input-group' : ''"
                                >
                                    <b-form-input v-model="formData.reference"/>
                                </b-input-group>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                  <b-col>
                      <div class="flex-grow-1 mr-2">
                          <ValidationProvider name="file" rules="" v-slot="{valid, errors}">
                          <b-form-group :label="$t('upload_file')">
                              <div class="d-flex custom-file-upload">
                                  <b-form-file v-model="formData.file"
                                               :placeholder="$t('select_file')"
                                               :drop-placeholder="$t('drop_file')"
                                               ref="fileInput"
                                  />
                                  <b-button variant="outline-secondary" @click="()=>{$refs.fileInput.$el.childNodes[0].click();}">
                                      {{ $t('browse') }}
                                  </b-button>
                              </div>
                          </b-form-group>
                              <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                          </ValidationProvider>

                      </div>

                  </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Components
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete.vue';
    import StatusSelectbox from '@/components/interactive-fields/StatusSelectbox.vue';
    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import GlossaryServices from "@/services/GlossaryServices";

    export default {
        components: {
            FacultySelectbox,
            StaffAutoComplete,
            StatusSelectbox,
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                formData: {
                    file:null
                },
                formLoading: false
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {
                    this.formLoading = true;
                    const formData = new FormData();
                    const file = this.formData.file;
                    if(file) {
                        formData.append('file', file);
                    }
                    formData.append('term', this.formData.term);
                    formData.append('definition', this.formData.definition);
                    formData.append('reference', this.formData.reference);
                    GlossaryServices.store(formData)
                                      .then(response => {
                                          this.$emit('createFormSuccess', true);
                                          this.$toast.success(this.$t('api.' + response.data.message));
                                      })
                                      .catch(e => {
                                          this.showErrors(e, this.$refs.formModalValidate);
                                      })
                                      .finally(() => {
                                          this.formLoading = false
                                      })
                }
            }
        }
    }
</script>

